import { createFileRoute } from '@tanstack/react-router';

import { IntegrationJourneyFlow } from '../features/demand/integrations/components/IntegrationDetailsPage/IntegrationJourneyFlow';

export const Route = createFileRoute(
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details/journey',
)({
  component: IntegrationJourneyFlowRoute,
});

function IntegrationJourneyFlowRoute() {
  const { integrationId } = Route.useParams();
  return <IntegrationJourneyFlow integrationId={integrationId} />;
}
